<script></script>

<div class="dot-typing" style="--dots-color:var(--secondary-color);"></div>

<style>
    .dot-typing {
        position: relative;
        left: -9999px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: var(--dots-color);
        color: var(--dots-color);
        box-shadow:
            9984px 0 0 0 var(--dots-color),
            9999px 0 0 0 var(--dots-color),
            10014px 0 0 0 var(--dots-color);
        animation: dot-typing 1.5s infinite linear;
    }

    @keyframes dot-typing {
        0% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
        16.667% {
            box-shadow:
                9984px -10px 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
        33.333% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
        50% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px -10px 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
        66.667% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
        83.333% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px -10px 0 0 var(--dots-color);
        }
        100% {
            box-shadow:
                9984px 0 0 0 var(--dots-color),
                9999px 0 0 0 var(--dots-color),
                10014px 0 0 0 var(--dots-color);
        }
    }
</style>
